import {  NgModule        } from '@angular/core';
import {  Routes        , 
          RouterModule 
} from '@angular/router';

import {  RoutingPages          } from 'src/app/enums/routing/routing-pages.enum';
import {  LandingPage           } from 'src/app/pages/landing/landing.page';
import {  MainPage              } from 'src/app/pages/main/main.page';
import {  DashboardPage         } from 'src/app/pages/dashboard/dashboard.page';
import {  StatisticPage         } from 'src/app/pages/statistic/statistic.page';
import { TimePage               } from 'src/app/pages/timestable/time.page';
import { TimeDevicePage         } from 'src/app/pages/timestable/device/time.device.page';
import { TimeServicePage        } from 'src/app/pages/timestable/service/time.service.page';
import { OperatorCounterPage    } from 'src/app/pages/operator-counter/operator.counter.page';
import { MessagePage            } from 'src/app/pages/message/message.page';
import { AssignOperatorPage     } from 'src/app/pages/assign-operator/assign.operator.page';
import { ServiceManagementPage  } from 'src/app/pages/service-management/service.management.page';
import { OperatorManagementPage } from 'src/app/pages/operator-management/operator.management.page';
import { OrganizationDetailPage } from 'src/app/pages/organization-detail/organization.detail.page';
import { SiteDetailPage         } from 'src/app/pages/site-detail/site.detail.page';
import { BookingManagementPage  } from 'src/app/pages/booking/booking.management.page';
import { DeviceServicePage } from 'src/app/pages/device-service/device.service.page';
import { DeviceManagementPage } from 'src/app/pages/device-management/device.management.page';
import { OperatorPage } from 'src/app/pages/operator/operator.page';
import { DevicePage } from 'src/app/pages/device/device.page';
import { MediaOrganizationPage } from 'src/app/pages/media/media-organization/media-organization.page';
import { SlotAutomatePage } from 'src/app/pages/timestable/slot-automate/slot.automate.page';
import { SlotModelPage } from 'src/app/pages/timestable/slot-model/slot.model.page';
import { MediaServicePage } from 'src/app/pages/media/media-service/media-service.page';
import { MediaSitePage } from 'src/app/pages/media/media-site/media-site.page';
import { LicencePage } from 'src/app/pages/licence/licence.page';
import { SsoCallbackPage } from 'src/app/pages/sso-callback/sso.callback.page';

const routes: Routes = [
  {
    path      : `${RoutingPages.LANDING_OLD}`,
    component : LandingPage,
  },
  {
    path      : RoutingPages.SSO_CALLBACK,
    component : SsoCallbackPage,
  },
  {
    path      : `${RoutingPages.LANDING}`,
    component : LandingPage,
  },
  {
    path      : RoutingPages.MAIN,
    component : MainPage,
    children  : [
      {
        path      : RoutingPages.DASHBOARD,
        component : DashboardPage
      },
      {
        path      : RoutingPages.ORGANIZATION_DETAIL,
        component : OrganizationDetailPage
      },
      {
        path      : RoutingPages.SITE_DETAIL,
        component : SiteDetailPage
      },
      {
        path      : RoutingPages.STATISTIC,
        component : StatisticPage
      },
      {
        path      : RoutingPages.TIMESTABLE,
        component : TimePage,
      },
      {
        path      : RoutingPages.TIMESTABLE_DEVICE,
        component : TimeDevicePage
      },
      {
          path      : RoutingPages.TIMESTABLE_SERVICE,
          component : TimeServicePage
      },
      {
        path      : RoutingPages.SLOTAUTOMATE,
        component : SlotAutomatePage
      },
      {
        path      : RoutingPages.SLOTMODEL,
        component : SlotModelPage
      },
      {
        path      : RoutingPages.DEVICE_SERVICE,
        component : DeviceServicePage
      },
      {
        path      : RoutingPages.OPERATOR,
        component : OperatorPage
      },
      {
        path      : RoutingPages.DEVICE,
        component : DevicePage
      },
      {
        path      : RoutingPages.OPERATOR_COUNTER,
        component : OperatorCounterPage
      },
      {
        path      : RoutingPages.ASSIGN_OPERATOR,
        component : AssignOperatorPage
      },
      {
        path      : RoutingPages.MANAGEMENT_MESSAGE,
        component : MessagePage
      },
      {
        path      : RoutingPages.MANAGEMENT_SERVICE,
        component : ServiceManagementPage
      },
      {
        path      : RoutingPages.MANAGEMENT_DEVICE,
        component : DeviceManagementPage
      },
      {
        path      : RoutingPages.MANAGEMENT_BOOKING,
        component : BookingManagementPage
      },
      {
        path      : RoutingPages.MANAGEMENT_OPERATOR,
        component : OperatorManagementPage
      },
      /* {
        path      : RoutingPages.MEDIA_ORGANIZATION,
        component : MediaOrganizationPage
      },
      {
        path      : RoutingPages.MEDIA_SITE,
        component : MediaSitePage
      },
      {
        path      : RoutingPages.MEDIA_SERVICE,
        component : MediaServicePage
      }, */
      {
        path      : RoutingPages.LICENCE,
        component : LicencePage
      },
      {
        path: "**",
        redirectTo: RoutingPages.DASHBOARD
      }
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: "top", useHash: false } )
  ],
  exports: [
    RouterModule
  ]
})
export class RoutingModule { }
